export class StickyBarProduct extends HTMLElement {
  constructor() {
    super();

    this.pdpAddToCart = document.querySelector('button.add-to-cart[name="add"]');
    this.pdpSizeSelectors = document.querySelectorAll('input.opt-btn[type="radio"]');
    this.addToCart = this.querySelector('button');
    this.chatObserver();
  }

  init() {
    if (!this.pdpAddToCart || !this.pdpSizeSelectors) return;
    this.addListeners();
    this.checkUrlParam();
    this.toggleVissibility();

    if (this.pdpSizeSelectors.length === 0) {
      const available = this.querySelector('input[type="radio"]:checked').dataset.availability;
      const textAvailable = this.addToCart.dataset.textAvailable;
      const textUnavailable = this.addToCart.dataset.textUnavailable;
      if (available === 'true') {
        this.addToCart.textContent = textAvailable;
        this.addToCart.disabled = false;
      } else {
        this.addToCart.textContent = textUnavailable;
        this.addToCart.disabled = true;
      }
    }
  }

  toggleVissibility() {
    // Create the intersection observer
    const observer = new IntersectionObserver((entries) => {
      // Loop through the entries (can be multiple if you're observing multiple elements)
      entries.forEach(entry => {
        const offsetTop = entry.boundingClientRect.top;
        if (entry.isIntersecting) {
          this.classList.add('hide');
          document.querySelector('body .smart-accessibility-widget .sa-widget__cta.bottom-left').classList.remove('move-btn');
          document.querySelector('body #gladlyChat_container').classList.remove('move-btn');
        } else if ( offsetTop < 0) {
          this.classList.remove('hide');
          document.querySelector('body .smart-accessibility-widget .sa-widget__cta.bottom-left').classList.add('move-btn');
          document.querySelector('body #gladlyChat_container').classList.add('move-btn');
        }
      });
    }, {
      threshold: 1 // Trigger when at least 10% of the element is visible
    });

    // Start observing the target element
    observer.observe(this.pdpAddToCart);
  }

  chatObserver() {
    let elementInitiated = false;
    // Create a MutationObserver to monitor changes in the DOM
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const element = document.getElementById('gladlyChat_container');
          if (element) {
            this.init();
            // Stop observing after the element is found
            observer.disconnect();
            elementInitiated = true;
            break;
          }
        }
      }
    });

    // Configure the observer to watch for changes in the <body> element
    const config = { childList: true, subtree: true };

    // Start observing the <body> element
    observer.observe(document.body, config);

     // Set up a timeout to stop observing if the element is not found within a certain time
    setTimeout(() => {
      if (!elementInitiated) {
        this.init();
        observer.disconnect();
      }
    }, 10000); // 10 seconds timeout, adjust as needed
  }

  enableButton() {
    const available = this.querySelector('input[type="radio"]:checked').dataset.availability;
    const textAvailable = this.addToCart.dataset.textAvailable;
    const textUnavailable = this.addToCart.dataset.textUnavailable;
    if (available === 'true') {
      this.addToCart.textContent = textAvailable;
      this.addToCart.disabled = false;
    } else {
      this.addToCart.textContent = textUnavailable;
      this.addToCart.disabled = true;
    }
  }

  addListeners() {
    // ATC button
    this.addToCart.addEventListener('click', () => {
      if (this.pdpAddToCart) {
        this.addToCart.classList.add('is-loading');
        this.pdpAddToCart.click();
        setTimeout(() => {
          this.addToCart.classList.remove('is-loading');
        }, 2000);
      }
    });
    // PDP selectors
    this.pdpSizeSelectors.forEach((selector) => {
      selector.addEventListener('change', () => {
        const value = selector.value;
        this.querySelector(`input[type="radio"][value="${value}"]`).checked = true;
        this.enableButton();
      });
    });
    // Sticky selectors
    this.querySelectorAll('input[type="radio"]').forEach((selector) => {
      selector.addEventListener('change', () => {
        const value = selector.value;
        document.querySelector(`input.opt-btn[type="radio"][value="${value}"]`).click();
        this.enableButton();
      });
    });
  }

  checkUrlParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    // Check if a variant is selected on load
    if (variantId) {
      this.querySelector(`#stickybar-variant-${variantId}`).checked = true;
      this.enableButton();
    }
  }
}

customElements.define('sticky-bar-product', StickyBarProduct);